import Constant from '@/const';
import axios from 'axios';

const putCpptById = async (payload, id) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/inpatient/cppt/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default putCpptById;
